import { render, staticRenderFns } from "./payment-check.vue?vue&type=template&id=335c6608&scoped=true&"
import script from "./payment-check.vue?vue&type=script&lang=js&"
export * from "./payment-check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335c6608",
  null
  
)

export default component.exports